<div *ngIf="isTokenReady">
    <router-outlet></router-outlet>
  </div>
